
import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../context/LanguageContext';
import { useGuest } from '../context/GuestContext';
import '../styles/Hero.css';

import BubblePhysics from './BubblePhysics';

const imageNames = [
  'image1.jpg',
  'image2.jpg',
  'image3.jpg',
  'image4.jpg',
  'image5.jpg',
  'image6.jpg',
  'image7.jpg',
  'image8.jpg',
  'image9.jpg',
  'image10.jpg',
  'image11.jpg',
  'image12.jpg',
  'image13.jpg',
  'image14.jpg',
  'image15.jpg',
  'image16.jpg',
  'image17.jpg',
  'image18.jpg',
  'image19.jpeg',
  'image20.jpg',
  'image21.jpeg',
  'image22.jpg',
  'image23.jpg',
  'image24.jpg',
  'image25.jpg',
  'image26.jpeg',
  'image27.jpeg',
  'image28.jpg',
  'image29.jpeg',
  'image30.jpg',
  'image31.jpg',
  'image32.jpg',
  'image33.jpg',
  'image34.jpg',
  'image35.jpg',
  'image36.jpg',
  'image37.jpg',
  'image38.jpg',
  'image39.jpg',
  'image40.jpg',
  'image41.jpg',
  'image42.jpg',
  'image43.jpeg',
  'image44.jpeg',
  'image45.jpeg',
  'image46.jpg',
  'image47.jpeg',
  'image48.jpg',
  'image49.jpeg',
  'image50.jpg',
  'image51.jpeg',
  'image52.jpg',
  'image53.jpeg',
  'image54.jpg',
  'image55.jpeg',
  'image56.jpg',
  'image57.jpeg',
  'image58.jpg',
  'image59.jpg',
  'image60.jpeg',
  'image61.jpeg',
  'image62.jpg',
  'image63.jpeg',
  'image64.jpg',
  'image65.jpg',
  'image66.jpg',
  'image67.jpg',
  'image68.jpg',
  'image69.jpg',
  'image70.jpg',
  'image71.jpg',
  'image72.jpg',
  'image73.jpeg',
  'image74.jpeg',
  'image75.jpeg',
  'image76.jpg',
  'image77.jpg',
  'image78.jpg',
  'image79.jpg',
  'image80.jpeg',
  'image81.jpg',
  'image82.jpg',
  'image83.jpg',
  'image84.jpg',
  'image85.jpg',
  'image86.jpeg',
  'image87.jpg',
  'image88.jpg',
  'image89.jpg',
  'image90.jpeg',
  'image91.jpg',
  'image92.jpeg',
  'image93.jpg',
  'image94.jpeg',
  'image95.jpg',
  'image96.jpg',
  'image97.jpeg',
  'image98.jpeg',
  'image99.jpg',
  'image100.jpg',
  'image101.jpg',
  'image102.jpg',
  'image103.jpeg',
  'image104.jpeg',
  'image105.jpg',
  'image106.jpeg',
  'image107.jpeg',
  'image108.jpg',
  'image109.jpg',
  'image110.jpeg',
  'image111.jpeg',
  'image112.jpg',
  'image113.jpg',
  'image114.jpg',
  'image115.jpg',
  'image116.jpg',
  'image117.jpg',
  'image118.jpeg',
  'image119.jpeg',
  'image120.jpeg',
  'image121.jpeg',
  'image122.jpeg',
  'image123.jpeg',
  'image124.jpeg',
  'image125.jpeg',
];

const BADGES = {
  amiker: { role: 'Bride', side: 'bride' },
  gergely: { role: 'Groom', side: 'groom' },
  mate: { role: 'Groomsman', side: 'groom' },
  calum: { role: 'Groomsman', side: 'groom' },
  bence: { role: 'Groomsman', side: 'groom' },
  endre: { role: 'Groomsman', side: 'groom' },
  matyas: { role: 'Best Man', side: 'groom' },
  seonaid: { role: 'Maid of Honor', side: 'bride' },
  morag: { role: 'Mother of the Bride', side: 'bride' },
  anthony: { role: 'Father of the Bride', side: 'bride' },
};

const BADGE_COLORS = {
  groom: { stroke: '#9B8EC4', fill: 'rgba(155,142,196,0.1)', shadow: 'rgba(155, 142, 196, 0.3)' },
  bride: { stroke: '#C48EA0', fill: 'rgba(196,142,160,0.1)', shadow: 'rgba(196, 142, 160, 0.3)' },
};

const ScoutBadge = ({ role, side = 'groom' }) => {
  const c = BADGE_COLORS[side];
  return (
    <div className={`scout-badge scout-badge-${side}`}>
      <svg viewBox="0 0 120 140" width="45" height="53">
        <path d="M60 5 L110 35 L110 105 L60 135 L10 105 L10 35 Z" fill="none" stroke={c.stroke} strokeWidth="4" />
        <path d="M60 15 L102 41 L102 99 L60 125 L18 99 L18 41 Z" fill={c.fill} />
        <text x="60" y="68" textAnchor="middle" fill={c.stroke} fontFamily="Playfair Display, serif" fontSize={role.length > 16 ? '8' : role.length > 10 ? '11' : '16'} fontWeight="600" fontStyle="italic">{role}</text>
        <path d="M35 85 L60 95 L85 85" fill="none" stroke={c.stroke} strokeWidth="2" opacity="0.5" />
        <path d="M35 45 L60 35 L85 45" fill="none" stroke={c.stroke} strokeWidth="2" opacity="0.5" />
      </svg>
    </div>
  );
};

const Hero = () => {
  const { t } = useTranslation();
  const { guest, partnerName } = useGuest();
  const guestDisplayName = guest?.displayName || guest?.firstName;
  const coupleGreeting = partnerName ? `${guestDisplayName} & ${partnerName}` : guestDisplayName;
  const badgeData = guest?.special && BADGES[guest.special];
  const bubbles = useMemo(() => {
    const isMobile = window.innerWidth <= 600;
    const totalBubbles = isMobile ? 15 : 35;
    // Shuffle a copy of the image list so each refresh starts with a random order
    const shuffled = [...imageNames].sort(() => Math.random() - 0.5);

    return Array.from({ length: totalBubbles }, (_, i) => ({
      id: i,
      imageName: shuffled[i % shuffled.length],
      size: isMobile ? 65 + Math.random() * 50 : 85 + Math.random() * 70,
      initialX: Math.random() * window.innerWidth * 0.8,
    }));
  }, []);

  return (
    <section id="hero" className="hero">
      <div className="bubble-background">
        {bubbles.map((bubble) => (
          <BubblePhysics
            key={bubble.id}
            bubbleId={bubble.id}
            imageName={bubble.imageName}
            allImages={imageNames}
            size={bubble.size}
            initialX={bubble.initialX}
          />
        ))}
      </div>
      <motion.div
        className="hero-card"
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        {guest?.special === 'ambrus' ? (
          <>
            <h2>*BUUURP* A-Ambi, {t('hero.saveTheDate')}</h2>
            <p>*burp* Listen Ambi, y-you gotta *BUURP* come to this thing, {t('hero.theWeddingOf')}</p>
            <h1>Amiker *burp* & Gergely</h1>
            <p>*BUUURP* {t('hero.date')} — don't *burp* be late, or whatever</p>
          </>
        ) : guest?.special === 'amiker' ? (
          <>
            <h2>Hello, Beautiful Bride</h2>
            <p>It's your big day! Well, almost...</p>
            <h1>Amiker & Gergely</h1>
            <p>{t('hero.date')}</p>
            <p className="hero-special-note">Hangry Amiker is NOT invited.</p>
            {badgeData && <ScoutBadge role={badgeData.role} side={badgeData.side} />}
          </>
        ) : guest?.special === 'gergely' ? (
          <>
            <h2>Hello, Handsome Groom</h2>
            <p>You're marrying the love of your life!</p>
            <h1>Amiker & Gergely</h1>
            <p>{t('hero.date')}</p>
            <p className="hero-special-note">Don't be late to your own wedding.</p>
            {badgeData && <ScoutBadge role={badgeData.role} side={badgeData.side} />}
          </>
        ) : guest?.special === 'david' ? (
          <>
            <h2>{coupleGreeting}, {t('hero.saveTheDate')}</h2>
            <p>{t('hero.theWeddingOf')}</p>
            <h1>Amiker & SzarF*sz Kapitány</h1>
            <p>{t('hero.date')}</p>
          </>
        ) : guest?.special === 'calum' ? (
          <>
            <h2>{coupleGreeting}, {t('hero.saveTheDate')}</h2>
            <p>{t('hero.theWeddingOf')}</p>
            <h1>Amiker & Gergely</h1>
            <p>{t('hero.date')}</p>
            <p className="hero-special-note">P.S. You can bring Chibs.</p>
            {badgeData && <ScoutBadge role={badgeData.role} side={badgeData.side} />}
          </>
        ) : guest?.special === 'endre' ? (
          <>
            <h2>{coupleGreeting}, {t('hero.saveTheDate')}</h2>
            <p>{t('hero.theWeddingOf')}</p>
            <h1>Amiker & Gergely</h1>
            <p>{t('hero.date')}</p>
            <p className="hero-special-note">Lesz boxgép, ne aggódj!</p>
            {badgeData && <ScoutBadge role={badgeData.role} side={badgeData.side} />}
          </>
        ) : guest?.special === 'mate' ? (
          <>
            <h2>{coupleGreeting}, {t('hero.saveTheDate')}</h2>
            <p>{t('hero.theWeddingOf')}</p>
            <h1>Amiker & Gergely</h1>
            <p>{t('hero.date')}</p>
            <p className="hero-special-note">A Gundy fog tekerőzni.</p>
            {badgeData && <ScoutBadge role={badgeData.role} side={badgeData.side} />}
          </>
        ) : guest?.special === 'matyas' ? (
          <>
            <h2>{coupleGreeting}, {t('hero.saveTheDate')}</h2>
            <p>{t('hero.theWeddingOf')}</p>
            <h1>Amiker & Gergely</h1>
            <p>{t('hero.date')}</p>
            {badgeData && <ScoutBadge role={badgeData.role} side={badgeData.side} />}
          </>
        ) : guest?.special === 'bence' ? (
          <>
            <h2>{coupleGreeting}, {t('hero.saveTheDate')}</h2>
            <p>{t('hero.theWeddingOf')}</p>
            <h1>Amiker & Gergely</h1>
            <p>{t('hero.date')}</p>
            {badgeData && <ScoutBadge role={badgeData.role} side={badgeData.side} />}
          </>
        ) : guest?.special === 'seonaid' ? (
          <>
            <h2>{coupleGreeting}, {t('hero.saveTheDate')}</h2>
            <p>{t('hero.theWeddingOf')}</p>
            <h1>Amiker & Gergely</h1>
            <p>{t('hero.date')}</p>
            {badgeData && <ScoutBadge role={badgeData.role} side={badgeData.side} />}
          </>
        ) : guest?.special === 'morag' ? (
          <>
            <h2>{coupleGreeting}, {t('hero.saveTheDate')}</h2>
            <p>{t('hero.theWeddingOf')}</p>
            <h1>Amiker & Gergely</h1>
            <p>{t('hero.date')}</p>
            {badgeData && <ScoutBadge role={badgeData.role} side={badgeData.side} />}
          </>
        ) : guest?.special === 'gyula' ? (
          <>
            <h2>{coupleGreeting}, {t('hero.saveTheDate')}</h2>
            <p>{t('hero.theWeddingOf')}</p>
            <h1>Amiker & Gergely</h1>
            <p>{t('hero.date')}</p>
            <p className="hero-special-note">Igen, open bar lesz!</p>
            <p className="hero-special-note">{t('hero.plusOne')}</p>
          </>
        ) : guest?.special === 'anthony' ? (
          <>
            <h2>{coupleGreeting}, {t('hero.saveTheDate')}</h2>
            <p>{t('hero.theWeddingOf')}</p>
            <h1>Amiker & Gergely</h1>
            <p>{t('hero.date')}</p>
            {badgeData && <ScoutBadge role={badgeData.role} side={badgeData.side} />}
          </>
        ) : (
          <>
            <h2>{coupleGreeting}, {t('hero.saveTheDate')}</h2>
            <p>{t('hero.theWeddingOf')}</p>
            <h1>Amiker & Gergely</h1>
            <p>{t('hero.date')}</p>
            {guest?.plusOne && <p className="hero-special-note">{t('hero.plusOne')}</p>}
          </>
        )}
      </motion.div>
    </section>
  );
};

export default Hero;
